// extracted by mini-css-extract-plugin
export default {"Triple_wrapper":"SkdnBNuBkpYa4tfcF80v","Triple":"y8fzh5Uew3yZExxbZFXw","Triple_wrapper__two":"RBPQwQXTmytKOTt6XdQt","Triple_wrapper__services":"ZccYq9XkkB5tXSVC_aFT"};